import {combineReducers} from "redux"
import feedback from "./FeedbackReducer"


export default combineReducers({
	feedback
})
